export enum EldHoursMethod {
  HosTypeBased = 0,
  StartEndBased = 1,
  HosTypeWithAutoOnDuty = 2
}

export const EldHoursMethodMapping: Record<EldHoursMethod, string> = {
  [EldHoursMethod.HosTypeBased]: 'HOS Type Based',
  [EldHoursMethod.StartEndBased]: 'Start => End',
  [EldHoursMethod.HosTypeWithAutoOnDuty]: 'HOS with Auto On-Duty - Motive'
};
